import { FC } from "react";

type IProps = {
  stroke?: string;
};

const MailOpen: FC<IProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.5252 5.70166L13.5584 4.06021V1.73147C13.5584 1.53041 13.3829 1.37686 13.1782 1.37686H10.3157L9.16782 0.419046C8.4915 -0.14029 7.51175 -0.14029 6.83543 0.422702L5.68751 1.37686H2.78847C2.5874 1.37686 2.40827 1.52675 2.40827 1.73147V4.09677L0.478009 5.70166C0.397582 5.77112 0.350057 5.87714 0.353712 5.98316H0.361024V14.1685C0.361024 15.1775 1.17261 16 2.17795 16H13.8216C14.8306 16 15.6386 15.1738 15.6386 14.1685V5.98316H15.6459C15.6532 5.87348 15.6093 5.77112 15.5252 5.70166ZM13.5584 5.01072L14.71 5.96853L13.5584 6.82399V5.01072ZM7.30337 0.982038C7.70916 0.645705 8.29774 0.649361 8.70354 0.985693L9.16782 1.37686H6.83177L7.30337 0.982038ZM3.13942 2.10802H12.8273V7.3687L8.66332 10.4688C8.2685 10.7576 7.73475 10.7576 7.34358 10.4688L3.13942 7.33946V2.10802ZM2.40827 5.04362V6.79474L1.29325 5.96488L2.40827 5.04362ZM14.9111 14.1648C14.9147 14.7717 14.4285 15.2652 13.8253 15.2689H2.17795C1.57475 15.2652 1.08853 14.7717 1.09218 14.1685V6.71066L6.9122 11.0574C7.55927 11.5363 8.44397 11.5363 9.09105 11.0574L14.9111 6.71066V14.1648Z"
        fill="white"
      />
      <path
        d="M7.70933 5.03271H5.73521C5.53414 5.03271 5.36963 5.19723 5.36963 5.39829C5.36963 5.59936 5.53414 5.76387 5.73521 5.76387H7.70933C7.9104 5.76387 8.07491 5.59936 8.07491 5.39829C8.07491 5.19723 7.9104 5.03271 7.70933 5.03271ZM10.2684 6.86061H5.73521C5.53414 6.86061 5.36963 7.02512 5.36963 7.22619C5.36963 7.42726 5.53414 7.59177 5.73521 7.59177H10.2684C10.4695 7.59177 10.634 7.42726 10.634 7.22619C10.634 7.02512 10.4695 6.86061 10.2684 6.86061Z"
        fill="white"
      />
    </svg>
  );
};

export default MailOpen;
